export const bplrtURL = process.env.REACT_APP_ITXCAST_API_URL;

export const bplrtOptions = {
  BPLRT_EQUIPMENT: {
    label: "BreakdownImage",
    value: "BPLRT_EQUIPMENT",
    htmlSrc: "equipment-image.html",
  },
  BPLRT_EQUIPMENT_TABLE: {
    label: "BreakdownTable",
    value: "BPLRT_EQUIPMENT_TABLE",
    htmlSrc: "breakdown-table.html",
  },
  BPLRT_SCHEDULE: {
    label: "Schedule",
    value: "BPLRT_SCHEDULE",
    htmlSrc: "train-schedule.html",
  },
  BPLRT_SERVICE_INFO: {
    label: "ServiceInfo",
    value: "BPLRT_SERVICE_INFO",
    htmlSrc: "service-info.html",
  },
  BPLRT_SMP: {
    label: "SMP",
    value: "BPLRT_SMP",
    htmlSrc: "smp.html",
  },
};

export const getPublicHtmlAsset = (assetID) => {
  return `${bplrtURL}/api/asset/${assetID}/file`;
};
